// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"be5c50d0","411":"d791fe65","436":"2ae1fe70","453":"4e3a932c","515":"42360bc7","821":"abd5c927","902":"f416a44d","976":"f2c4e215"}[chunkId] + ".chunk.js";
};